import $ from 'jquery';

$('body').on('click', '.catalog-detail-gallery__item--preview', function () {
    $('.catalog-detail-gallery__item--big img').remove();
    const imgSrc = $(this).attr('data-src');
    const imgSrcLarge = $(this).attr('data-src-large');
    $('.catalog-detail-gallery__item--big').append(`<img src="${imgSrc}" data-src-large="${imgSrcLarge}"/>`);
});

const lensZoom = 3;

$('.catalog-detail-gallery__item--big').on('mouseenter', 'img', function (e) {
    $('.catalog-detail-gallery-lens__inner img').remove();
    const imgSrc = $(this).attr('data-src-large');
    $('.catalog-detail-gallery-lens__inner').append(`<img src="${imgSrc}"/>`);
    $('.catalog-detail-gallery-lens__inner img').width($(this).width() * lensZoom);

    $('.catalog-detail-gallery-lens').show();
});

$('.catalog-detail-gallery__item--big').on('mouseleave', 'img', function (e) {
    $('.catalog-detail-gallery-lens').hide();
});

$('.catalog-detail-gallery__item--big').on('mousemove', 'img', function (e) {
    const image = $('.catalog-detail-gallery-lens__inner img');
    const inner = $('.catalog-detail-gallery-lens__inner');

    const mouseY = e.offsetY;
    const thisHeight = $(this).height();
    const imageHeight = image.height();
    const innerHeight = inner.height();

    const mouseCenterOffsetY = (mouseY - (thisHeight / 2)) / (thisHeight / 2);
    const imageCenterOffsetY = (innerHeight - imageHeight) / 2;
    const imageTop = imageCenterOffsetY - (imageHeight / 2) * mouseCenterOffsetY;

    const mouseX = e.offsetX;
    const thisWidth = $(this).width();
    const imageWidth = image.width();
    const innerWidth = inner.width();

    const mouseCenterOffsetX = (mouseX - (thisWidth / 2)) / (thisWidth / 2);
    const imageCenterOffsetX = (innerWidth - imageWidth) / 2;
    const imageLeft = imageCenterOffsetX - (imageWidth / 2) * mouseCenterOffsetX;

    image.css('left', imageLeft)
        .css('top', imageTop);
});
